<template>
  <div id="synthitcDataH5" ref="BigBox">
    <div class="box-top">
      <div class="box-img" @click="Optionsidebar">
        <img class="iconImg" src="https://xmyun.zhoty.com/xmerp/xmapp/xmapp-report-menu.png" alt="">
      </div>
    </div>
        <div id="box">
      <!-- 侧边栏-->
      <div id="left-box">
        <el-menu
          class="el-menu-vertical-demo"
           default-active="签约数据"
          :collapse="isCollapse"
           @select="selsectOpen"
           :unique-opened="true"
        >
        <!-- 一级 -->
          <el-submenu class="elsubmenu" :index="item.menuName +''" v-for="(item,index) in TreeList" :key="index">
            <template slot="title">
              <!-- <i class="el-icon-location"></i> -->

              <!-- <img :src="item.menuIcon" alt=""> -->
              <span slot="title">{{item.menuName}}</span>
            </template>
            <!-- 二级 -->
            <el-menu-item-group v-for="(itemTow,index) in item.children" :key="index">
              <el-menu-item :index="itemTow.menuName + ''">{{itemTow.menuName}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <!-- 数据报表 -->
      <div id="right-box" @click.stop="showOption">   
        <!-- 运营 -->
        <OperationaDataReportOne v-if="selsectData == '立项数据'" ref="OperationaDataReportOne"></OperationaDataReportOne>  
        <BidsData v-if="selsectData == '招标数据'" ref="BidsData"></BidsData>
        <!-- <OperationaDataReportTwo v-if="selsectData == '投标数据'" ref="OperationaDataReportTwo"></OperationaDataReportTwo> -->
        <!-- <BiddingData v-if="selsectData == '中标数据'" ref="BiddingData"></BiddingData>  -->
        <SignedData v-if="selsectData == '签约数据'" ref="SignedData"></SignedData>
        <OperationaDataReportThree v-if="selsectData == '丢单数据'" ref="OperationaDataReportThree"></OperationaDataReportThree>
        <!-- 工程 -->
        <CollectData v-if="selsectData == '汇总数据'" ref="CollectData" />
        <!-- 精英库 -->
        <EliteDirectorDataReportOne v-if="selsectData == '总监数据'" ref="EliteDirectorDataReportOne"></EliteDirectorDataReportOne>
        <HoldCertificateData v-if="selsectData == '持证数据'" ref="HoldCertificateData"></HoldCertificateData>
        <!-- 客户 -->
        <CustomerOwnerDataReportOne v-if="selsectData == '甲方数据'" ref="CustomerOwnerDataReportOne"></CustomerOwnerDataReportOne>
        <CustomerOwnerDataReportTwo v-if="selsectData == '入库备案数据'" ref="CustomerOwnerDataReportTwo"></CustomerOwnerDataReportTwo>
        <!-- 财务 -->
        <waterData v-if="selsectData == '流水数据'" ref="waterData" />
        <receivableData v-if="selsectData == '应收数据'" ref="receivableData" />
        <dealWithData v-if="selsectData == '应付数据'" ref="dealWithData" />
        <closeAccountsData v-if="selsectData == '结算数据'" ref="closeAccountsData" />
        <sendOrdersData v-if="selsectData == '派单数据'" ref="sendOrdersData"/>
        <pollingData v-if="selsectData == '巡检数据'" ref="pollingData" />
        <abnormalData v-if="selsectData == '异常数据'" ref="abnormalData" />
        <designData v-if="selsectData == '设计数据'" ref="designData" />
        <sellingData v-if="selsectData == '购销数据'" ref="sellingData" />
      </div>
    </div>
  </div>
</template>

<script>
// 运营
import OperationaDataReportOne from '@/components/ReportComponentPage/OperationaDataReportOne'
import BidsData from '@/views/operationData/bidsData'
// import OperationaDataReportTwo from '@/components/ReportComponentPage/OperationaDataReportTwo'
// import BiddingData from '@/views/operationData/biddingData'
import SignedData from '@/views/operationData/signedData'
import OperationaDataReportThree from '@/components/ReportComponentPage/OperationaDataReportThree'
// 工程
import CollectData from '@/views/engineeringData/collectData'
// 精英库
import EliteDirectorDataReportOne from '@/components/ReportComponentPage/EliteDirectorDataReportOne'
import HoldCertificateData from '@/components/ReportComponentPage/EliteCertificateDataReportTwo'
// 客户
import CustomerOwnerDataReportOne from '@/components/ReportComponentPage/CustomerOwnerDataReportOne'
import CustomerOwnerDataReportTwo from '@/components/ReportComponentPage/CustomerOwnerDataReportTwo'
// 财务
import waterData from '@/views/financialData/waterData'
import receivableData from '@/views/financialData/receivableData'
import dealWithData from '@/views/financialData/dealWithData'
import closeAccountsData from '@/views/financialData/closeAccountsData'
import sendOrdersData from '@/views/engineeringData/sendOrdersData'
import pollingData from '@/views/engineeringData/pollingData'
import abnormalData from '@/views/engineeringData/abnormalData'
import designData from '@/views/designData/designData'
import sellingData from '@/views/sellingData/sellingData'
import * as Urls from '@/helper/Urls';
export default {
  components:{
    CustomerOwnerDataReportTwo,
    CustomerOwnerDataReportOne,
    HoldCertificateData,
    OperationaDataReportOne,
    BidsData,
    // OperationaDataReportTwo,
    // BiddingData,
    SignedData,
    CollectData,
    OperationaDataReportThree,
    EliteDirectorDataReportOne,
    waterData,
    receivableData,
    dealWithData,
    closeAccountsData,
    sendOrdersData,
    pollingData,
    abnormalData,
    designData,
    sellingData
  },
  data() {
    return {
      isCollapse: true,
      identification:'',
      TreeList:[],
      phone:'',
      selsectData:'签约数据'
    };
  },
  created(){
    this.phone = this.$route.query.phone
    if (this.phone) {
        this.getPermissions()
    } 
  },
  mounted(){
  },
  methods:{
    initData(tyep) {
      switch(tyep) {
        // 运营
        case '立项数据' :
          this.$nextTick(()=>{
          this.$refs.OperationaDataReportOne.init()
          })
          break;
          case '招标数据' :
          this.$nextTick(()=>{
          this.$refs.BidsData.init()
          })
          break;
        // case '投标数据' :
        //   this.$nextTick(()=>{
        //   this.$refs.OperationaDataReportTwo.init()
        //   })
        //   break;
        // case '中标数据' :
        //   this.$nextTick(()=>{
        //   this.$refs.BiddingData.init()
        //   })
        //   break;    
        case '签约数据' :
          this.$nextTick(()=>{
          this.$refs.SignedData.init()
          })
          break;   
        case '丢单数据' :
          this.$nextTick(()=>{
          this.$refs.OperationaDataReportThree.init()
          })
          break; 
        // 工程 
        case '汇总数据' :
          this.$nextTick(()=>{
          this.$refs.CollectData.init()
          })
          break; 
        // 精英库
        case '总监数据' :
          this.$nextTick(()=>{
          this.$refs.EliteDirectorDataReportOne.init()
          })
          break;  
        case '持证数据' :
          this.$nextTick(()=>{
          this.$refs.HoldCertificateData.init()
          })
          break;  
        // 客户 
        case '甲方数据' :
          this.$nextTick(()=>{
          this.$refs.CustomerOwnerDataReportOne.init()
          })
          break;
        case '入库备案数据' :
          this.$nextTick(()=>{  
          this.$refs.CustomerOwnerDataReportTwo.init()
          })
          break;
        // 财务 
        case '流水数据':
          this.$nextTick(()=>{
            this.$refs.waterData.init();
          })
          break;
        case '应收数据':
          this.$nextTick(()=>{
            this.$refs.receivableData.init();
          })
          break;
        case '应付数据':
          this.$nextTick(()=>{
            this.$refs.dealWithData.init();
          })
          break;
        case '结算数据':
          this.$nextTick(()=>{
            this.$refs.closeAccountsData.init();
          })
          break;
        case '派单数据':
          this.$nextTick(()=>{
            this.$refs.sendOrdersData.init();
          })
          break;
        case '巡检数据':
          this.$nextTick(()=>{
            this.$refs.pollingData.init();
          })
          break;
        case '异常数据':
          this.$nextTick(()=>{
            this.$refs.abnormalData.init();
          })
          break;
        case '设计数据':
          this.$nextTick(()=>{
            this.$refs.designData.init();
          })
          break;
        case '购销数据':
          this.$nextTick(()=>{
            this.$refs.sellingData.init();
          })
          break;
      }
    },
    // 获取权限
    getPermissions(){
        let _this = this
        let url = Urls.getAuthorizeBackRole
        let params = {
            phone:this.phone
        }
        this.$root.doPost(url,params,function(server_data){
         // 应用错误
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
          sessionStorage.setItem('token', server_data.data.token);
          _this.getMenuBar();
          _this.initData(_this.selsectData);
        })
    },  
    selsectOpen(val){
      this.selsectData = val
      this.isCollapse = !this.isCollapse
      this.initData(val)
    },
    // 打开侧边栏
    Optionsidebar(){
      this.isCollapse = !this.isCollapse 
    },
    // 获取导航栏
    getMenuBar(){
      let _this = this
      let url = Urls.getXappReportMenuByRole
      let params = ''
      this.$root.doPost(url,params,function(server_data){
         if(server_data.error){
             _this.$root.showGlobalError(server_data.error);
             return;
         }
         _this.TreeList = server_data.data[0].children
      })
    },
    showOption(){
      this.isCollapse = true
    }
    
  },
  watch:{

  }
}
</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
#synthitcDataH5{
  overflow: hidden;
  width: 100%;
  background-color: #f5f5f5;
  #box{
    #left-box{
      background-color: #fff;
      
    }
  }
  .box-top{
    // position: fixed;
    // top: 0;
    // left: 0;
    height: 0.4rem;
    background-color: #fff;
    .box-img{
      height: 0.3rem;
      width: 0.3rem;
      position: relative;
    }
    .iconImg{
      position: absolute;
      top: 15%;
      left: 50%;
      width: 100%;
      height: 100%;
    }
  }
    #box {
    display: flex;
   #right-box{
    width: 100% !important;
  }
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    height: calc(100vh - 80px);
    width: 12.5rem;
    min-height: 400px;
    z-index: 999;
  }
  .el-menu--collapse {
    width: 0;
    height: calc(100vh - 80px);
  }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-menu {
    border: none;
  }

 
  // .el-menu-vertical-demo{
  //     .el-submenu{
  //        .el-submenu__title {
  //         background: red;
  //         padding-left: 0 !important;
  //         padding:0 !important;
  //           span{
  //             padding-left: 20px;
  //           }
  //       }
  //     }
  //     }
}
.elsubmenu .el-submenu__title{
  background: red;
}
</style>

<style lang="scss">
#synthitcDataH5 #left-box .el-submenu__title{
  padding: 0;
  padding-left: 0!important;
  span{
    display: inline-block;
    padding-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// syntheticDataH5.vue?d625b7cc